import { j as s } from "./jsx-runtime-DmTjM30f.mjs";
import { useState as b, useEffect as h } from "react";
import { I as e } from "./ic_arrowless_fill-EoSHNXJu.mjs";
import { t as j } from "./throttle-CbOTDqvg.mjs";
import { c as v } from "./tw-cn-mXgPecoF.mjs";
import { F as y } from "./floating-button-XxUwMo0R.mjs";
const N = ({
  top: n = 150,
  scrollBehavior: t = "smooth",
  targetRef: o,
  onClick: l,
  className: m,
  hasGnb: d = !1,
  style: p
}) => {
  const [a, u] = b(!1);
  h(() => {
    const r = (o == null ? void 0 : o.current) || window, i = j(() => {
      var c;
      const w = ((c = o == null ? void 0 : o.current) == null ? void 0 : c.scrollTop) ?? window.scrollY;
      u(w > n);
    }, 100);
    return i(), r.addEventListener("scroll", i), () => {
      r.removeEventListener("scroll", i);
    };
  }, [n, o == null ? void 0 : o.current]);
  const x = () => {
    ((o == null ? void 0 : o.current) || window).scrollTo({ top: 0, behavior: t }), l == null || l();
  };
  return /* @__PURE__ */ s.jsx(
    "div",
    {
      className: v(
        "fixed left-1/2 w-full max-w-mobile-size -translate-x-1/2 transition-all duration-300 z-middle pc:bottom-24 pc:max-w-[none]",
        a ? "translate-y-0 opacity-100" : "translate-y-100 opacity-0",
        d ? "bottom-80" : "bottom-16",
        m
      ),
      style: p,
      children: /* @__PURE__ */ s.jsx("div", { className: "absolute bottom-0 right-16 pc:right-24", children: /* @__PURE__ */ s.jsx(y, { icon: /* @__PURE__ */ s.jsx(e, {}), onClick: x }) })
    }
  );
};
export {
  N as G
};
